import { render, staticRenderFns } from "./PermissionModalTable.vue?vue&type=template&id=623ebfc5&scoped=true&lang=pug"
import script from "./PermissionModalTable.vue?vue&type=script&lang=js"
export * from "./PermissionModalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ebfc5",
  null
  
)

export default component.exports